
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/season/[queuedSlug]",
      function () {
        return require("private-next-pages/season/[queuedSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/season/[queuedSlug]"])
      });
    }
  